import { render, staticRenderFns } from "./dossier-detail-component-tabs-with-general-and-lots.vue?vue&type=template&id=5ecbf1e2&scoped=true"
import script from "./dossier-detail-component-tabs-with-general-and-lots.vue?vue&type=script&lang=ts"
export * from "./dossier-detail-component-tabs-with-general-and-lots.vue?vue&type=script&lang=ts"
import style0 from "./dossier-detail-component-tabs-with-general-and-lots.vue?vue&type=style&index=0&id=5ecbf1e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecbf1e2",
  null
  
)

export default component.exports